import { FC } from 'react';
import { ReactComponent as Logo } from '../../assets/logo/andCOCO_logo.svg';
import { Link } from '../Link.client';
import { DesktopHeaderDetail } from './DesktopHeaderDetail.client';
import { DesktopNavigation } from './DesktopNavigation.client';

interface Props {
  isLogin: boolean;
  onClickSearch: () => void;
}

export const DesktopHeader: FC<Props> = ({ onClickSearch }) => (
  <>
    <div className="bg-brand py-1">
      <div className="wrapper flex justify-between text-sm text-white">
        <p>
          ペットのメモリアルグッズ <span className="font-outfit">＆COCO</span>
        </p>
        <p>新規会員登録で10%OFFクーポン</p>
        <Link route="url" url="https://cocopet.jp/" target="_blank">
          ペット葬儀の<span className="font-outfit">COCOペット</span>はこちら
        </Link>
      </div>
    </div>
    <div className="mt-2">
      <div className="wrapper flex justify-between">
        <div>
          <ul className="mb-2 flex gap-x-6 text-sm font-semibold">
            <li>
              <Link route="about">
                <span className="font-outfit">＆COCO</span>とは
              </Link>
            </li>
            <li>
              <Link route="news">お知らせ</Link>
            </li>
          </ul>
        </div>
        <DesktopHeaderDetail onClickSearch={onClickSearch} />
      </div>
    </div>
    <div className="wrapper mb-2 flex justify-center">
      <Link route="home">
        <Logo width={150} />
      </Link>
    </div>
    <DesktopNavigation />
  </>
);
